import ExternalIcon from "../../../assets/external-icon.svg";

export function Reference() {
  return (
    <div className="bg-white rounded-lg ring-1 ring-gray-250v2 shadow-sm p-6 flex flex-col gap-2">
      <h3 className="font-inter font-medium text-xs leading-4 tracking-[0.05em] uppercase text-gray-550 text-left">
        REFERENCE
      </h3>
      <div className="flex flex-col gap-2">
        <h4 className="font-inter font-medium text-base leading-6 text-gray-950 text-left">
          EU AI Act
        </h4>
        <p className="font-inter font-normal text-sm leading-5 text-gray-800 text-left mb-4">
          The official Regulation (EU) 2024/1689 on Artificial Intelligence (AI
          Act) for complete legal requirements and definitions.
        </p>
        <a
          href="https://eur-lex.europa.eu/eli/reg/2024/1689"
          target="_blank"
          rel="noopener noreferrer"
          className="py-2 px-4 rounded-md ring-1 ring-gray-400 bg-gray-40 flex items-center gap-3 cursor-pointer hover:bg-gray-100 transition-colors"
        >
          <span className="font-inter font-normal text-sm leading-5 text-gray-950 text-left">
            View The EU AI Act
          </span>
          <img src={ExternalIcon} alt="External link" className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
